import axios from "@/axios";

export default {
  getLessonScreens({commit, state}, uuid) {
    return new Promise((resolve, reject) => {
      axios.get(`/cp/lessons/${uuid}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getLessonScreen({commit, state}, uuid) {
    return new Promise((resolve, reject) => {
      axios.get(`/cp/lesson-screens/${uuid}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  bulkAddLessonScreens({state}, payload) {
    return new Promise((resolve, reject) => {
      axios.post(`/cp/lessons/${payload.uuid}/lesson-screens/bulk`, payload.lesson_screens)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  deleteLessonScreen({state}, uuid) {
    return new Promise((resolve, reject) => {
      axios.delete(`/cp/lesson-screens/${uuid}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },


}
